import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._filterEl = options.filterEl;
        this._listEl = options.listEl;
        this._placeholder = options.placeholder;
        this._cta = options.cta;
        this._ctaReset = options.reset;
        this._structureKeys = options.structureKeys;
        this._showSiteUrl = options.showSiteUrl;
        this._groupId = options.groupId;
        this._fields = JSON.parse(options.fields);
        this._searchString = writable('');
        this._field = writable('');
        this._category = writable('');
        this._archiveIncluded = writable(false);
    }
    resetFilter() {
        this.searchString = '';
        this.field = '';
        this.category = '';
        this.archiveIncluded = false;
    }
    get isFilterActive() {
        return !!(this.field || this.category || this.searchString || this.archiveIncluded);
    }
    get filterEl() {
        return this._filterEl;
    }
    get listEl() {
        return this._listEl;
    }
    get placeholder() {
        return this._placeholder;
    }
    get cta() {
        return this._cta;
    }
    get ctaReset() {
        return this._ctaReset;
    }
    get showSiteUrl() {
        return this._showSiteUrl;
    }
    get groupId() {
        return this._groupId;
    }
    // filter
    get fields() {
        return this._fields;
    }
    // searchString
    set searchString(string) {
        this._searchString.set(string);
    }
    get searchString() {
        return get(this._searchString);
    }
    get searchStringSubs() {
        return this._searchString;
    }
    get searchParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("q") || "";
    }
    // field / oblast
    set field(value) {
        this._field.set(value);
    }
    get field() {
        return get(this._field);
    }
    get fieldParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const field = urlParams.get("oblast");
        return field && this.fields.some(item => String(item.id) === field) ? field : '';
    }
    // category / kategorie
    set category(value) {
        this._category.set(value);
    }
    get category() {
        return get(this._category);
    }
    get categoryParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("kategorie") || '';
    }
    // also archive / Prohledávat včetně archivu
    set archiveIncluded(value) {
        this._archiveIncluded.set(value);
    }
    get archiveIncluded() {
        return get(this._archiveIncluded);
    }
    get archiveIncludedParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const archiveIncluded = urlParams.get("archived");
        return archiveIncluded === 'true';
    }
    // common
    get pageParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("strana");
        return page ? parseInt(page) : 1;
    }
    get pageSizeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageSize = urlParams.get("pocet");
        return pageSize ? parseInt(pageSize) : 10;
    }
    get apiStructureKeys() {
        if (typeof this._structureKeys === "string") {
            return this._structureKeys.split("|");
        }
        else {
            return [];
        }
    }
}
